import { render, staticRenderFns } from "./UsuarioConfig.vue?vue&type=template&id=8f8d0ee0&"
import script from "./UsuarioConfig.vue?vue&type=script&lang=js&"
export * from "./UsuarioConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports